<template>
  <div class="board-container">
    <button @click="addPanel" class="add-panel-btn">+ Yeni Panel Ekle</button>
    
    <draggable 
      v-model="panels" 
      item-key="id"
      class="panels-wrapper"
      ghost-class="ghost-panel"
      handle=".panel-drag-handle"
    >
      <template #item="{ element: panel, index }">
        <div class="panel">
          <div class="panel-header">
            <span class="panel-drag-handle">⠿</span>
            <input v-model="panel.title" class="panel-title-input" />
            
            <div class="header-actions">
              <button @click="addTask(panel)" class="add-task-btn">+</button>
              <button @click="removePanel(index)" class="remove-panel-btn">×</button>
            </div>
          </div>

          <draggable 
            v-model="panel.items" 
            group="shared-tasks" 
            item-key="id"
            class="drag-area"
            ghost-class="ghost-card"
          >
            <template #item="{ element: task }">
              <div class="task-card" @click="openTaskDetail(task)">
                <div class="task-text">{{ task.text || 'Başlıksız Görev...' }}</div>
              </div>
            </template>
          </draggable>
        </div>
      </template>
    </draggable>

    <transition name="fade">
      <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Görev Detayları</h3>
            <button @click="closeModal" class="close-modal-x">×</button>
          </div>
          
          <div class="modal-body" v-if="selectedTask">
            <label>Görev Metni</label>
            <textarea 
              v-model="selectedTask.text" 
              rows="6" 
              placeholder="Görev detaylarını buraya yazın..."
            ></textarea>
            
            <div class="modal-footer">
              <small>ID: {{ selectedTask.id }}</small>
              <button @click="closeModal" class="save-btn">Kapat</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

  <transition name="fade">
  <div v-if="isDeleteModalOpen" class="modal-overlay" @click.self="closeDeleteModal">
    <div class="modal-content delete-modal">
      <div class="modal-header">
        <h3>Paneli Sil?</h3>
        <button @click="closeDeleteModal" class="close-modal-x">×</button>
      </div>
      <div class="modal-body">
        <p><strong>"{{ panelToDelete?.title }}"</strong> isimli paneli ve içindeki tüm görevleri silmek istediğinize emin misiniz?</p>
      </div>
      <div class="modal-footer">
        <button @click="closeDeleteModal" class="cancel-btn">Vazgeç</button>
        <button @click="confirmDeletePanel" class="danger-btn">Evet, Sil</button>
      </div>
    </div>
  </div>
</transition>
</template>

<script setup>
import { ref, watch } from 'vue';
import draggable from 'vuedraggable';

// Modal ve Seçili Görev Durumu
const isModalOpen = ref(false);
const selectedTask = ref(null);

// Başlangıç Verisi veya LocalStorage Verisi
const panels = ref(JSON.parse(localStorage.getItem('multiBoard')) || [
  {
    id: 'initial-1',
    title: 'Yapılacaklar',
    items: [{ id: 'task-101', text: 'Raporu hazırla' }]
  }
]);

// Yeni Panel Ekleme
const addPanel = () => {
  panels.value.push({ 
    id: crypto.randomUUID(), 
    title: 'Yeni Panel', 
    items: [] 
  });
};

// Script setup içine ekle
const isDeleteModalOpen = ref(false);
const panelToDelete = ref(null); // Silinecek paneli burada tutacağız

// Eski removePanel'i şu şekilde güncelle:
const removePanel = (index) => {
  // Direkt silmek yerine modalı açıyoruz
  panelToDelete.value = { 
    index, 
    title: panels.value[index].title 
  };
  isDeleteModalOpen.value = true;
};

// Modaldaki "Sil" butonuna basınca çalışacak fonksiyon:
const confirmDeletePanel = () => {
  if (panelToDelete.value !== null) {
    panels.value.splice(panelToDelete.value.index, 1);
    closeDeleteModal();
  }
};

const closeDeleteModal = () => {
  isDeleteModalOpen.value = false;
  panelToDelete.value = null;
};

// ÇÖZÜM: Parametre olarak gelen panel nesnesinin içine doğrudan ekliyoruz
const addTask = (targetPanel) => {
  targetPanel.items.push({ 
    id: crypto.randomUUID(), 
    text: 'Yeni Görev' 
  });
};

// Detay Açma
const openTaskDetail = (task) => {
  selectedTask.value = task;
  isModalOpen.value = true;
};

// Detay Kapatma
const closeModal = () => {
  isModalOpen.value = false;
  selectedTask.value = null;
};

// Verileri İzle ve Kaydet
watch(panels, (newVal) => {
  localStorage.setItem('multiBoard', JSON.stringify(newVal));
}, { deep: true });
</script>

<style scoped>
/* Mevcut stillerini korudum, temel yapı: */
.board-container {
  padding: 20px;
  background-color: #f4f5f7;
  min-height: 100vh;
}

.panels-wrapper {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  padding: 20px 0;
  overflow-x: auto;
}

.panel {
  background: #ebedf0;
  width: 300px;
  min-width: 300px;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border: 1px solid #bababa;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border-bottom:1px solid #d4d4d4;
  padding-bottom: 5px;
}

.panel-title-input {
  background: transparent;
  border: none;
  font-weight: bold;
  font-size: 1.1rem;
  /*width: 60%;*/
  font-family:Arial, Helvetica, sans-serif;
}

.drag-area {
  min-height: 150px;
}

.task-card {
  background: white;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.1s;
  border: 1px solid #d4d4d4;
}

.task-card:hover {
  background: #fafafa;
  transform: translateY(-2px);
}

.task-text {
  font-size: 0.95rem;
  color: #333;
  word-break: break-word;
  font-family: Arial, Helvetica, sans-serif;

  /* Kısaltma ayarları: */
  display: -webkit-box;
  -webkit-line-clamp: 4; /* Kart içinde en fazla 4 satır görünsün */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  
}

/* Modal Stilleri */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 450px;
  max-width: 90%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  font-family: Arial, Helvetica, sans-serif;
}

.modal-body {
  font-family: Arial, Helvetica, sans-serif;
}

.modal-body textarea {
  width: 420px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: Arial, Helvetica, sans-serif;
  resize: vertical;
}

.modal-footer {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  font-family: Arial, Helvetica, sans-serif;
}

.save-btn {
  background: #42b883;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}

.close-modal-x {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

/* Animasyonlar */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.add-panel-btn {
  background: #35495e; color: white; border: none; padding: 10px 20px;
  border-radius: 8px; cursor: pointer; font-weight: bold; margin-bottom: 10px;
}
.remove-panel-btn { background: #ff5252; color: white; border: none; border-radius: 4px; width: 24px; height: 24px; cursor: pointer; }
.add-task-btn { background: #42b883; color: white; border: none; border-radius: 4px; width: 24px; height: 24px; cursor: pointer; margin: 2px;}
.panel-drag-handle { cursor: grab; color: #999; font-size: 20px; margin-right: 10px; }
.ghost-panel { opacity: 0.2; border: 2px dashed #35495e; }
.ghost-card { opacity: 0.4; background: #c8ebfb !important; }


.delete-modal {
  border-top: 5px solid #ff5252; /* Üst kısma kırmızı bir uyarı çizgisi */
}

.cancel-btn {
  background: #eee;
  color: #333;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
}

.danger-btn {
  background: #ff5252;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}

.danger-btn:hover {
  background: #e33e3e;
}
</style>